import React from 'react'
import NavLink from '../Routes/NavLink'
import DropzoneComponent from 'react-dropzone-component';

import {dropZone} from '../../core/utilities/DropZoneHandler';
import {documents} from '../../core/controllers/Documents'

// #  TODO move this to seperate component
const DocumentAttachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url}/>
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class DocumentsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attachmentData: null
        };

        this.lastSortID = "0";
    }

    componentDidMount() {
        documents.getDocuments(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.lastSortID != nextProps.sortID) {
            this.lastSortID = nextProps.sortID;
            documents.getDocuments(this)
        }
    }

    triggerUpload() {
        var self = this;
        dropZone.upload(function() {
            documents.getDocuments(self);
        });
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            documents.getDocuments(self);
        });
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((data, index) => (
                    <DocumentAttachment key={index} attachment={data.attachments[0]} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            } else return (<p>No Documents Found, try adding some! </p>);
        } else return (<p>No Documents Found, try adding some! </p>);
    }

    render(){
        const attachments = this.renderAttachments(this.state.attachmentData);
        return (
            <div class="content">
                <div class="row">
                    {attachments}
                </div>
                <div class="row">
                    { this.state.dropZoneSetup !== undefined && (
                        <DropzoneComponent config={this.state.dropZoneConfig}
                            eventHandlers={this.state.dropZoneEventHandlers}
                            djsConfig={this.state.dropZoneJSConfig} />
                    )}
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Documents/DocumentsList.jsx